import { findDependents } from '@hc-frontend/business'
import { MemberType } from '@hc-frontend/entities'

import getGender from './getGender'

function makeMembers(members) {
  let countChildren = 0
  const length = members.length

  members = findDependents(members).map(({ type, stringDOB, gender }, index) => ({
    type:
      type === MemberType.Spouse
        ? 'Spouse/ Domestic Partner'
        : `Child ${++countChildren}`,
    dob: stringDOB,
    gender: getGender(gender),
    className: length === 1 ? 'one' : index % 2 === 0 ? 'first' : 'second'
  }))

  // response: [[{}, {}], [{}, {}]]
  const response = []
  while (members.length) {
    response.push(members.splice(0, 2))
  }

  return response
}

export default makeMembers
